export default ({ from, next }) => {
  let data_route = {
    name: from.name,
    query: from.query,
    params: from.params,
  };
  localStorage.setItem("route_from", JSON.stringify(data_route));
  return next();
};
